import { useAppSelector } from "../../redux/hooks";

export const useUserData = () => useAppSelector(state => state.header.userData);

export const useUserHasAnyTicket = () =>
  useAppSelector(state => {
    if (!state?.header?.userData?.FreeTicketNotification) {
      return false;
    }
    return (
      state.header.userData.FreeTicketNotification.AllAvailableFreeTickets > 0 ||
      state.header.userData.FreeTicketNotification.SubscriptionTickets > 0 ||
      state.header.userData.FreeTicketNotification.LoyaltyClubFreeTickets > 0 ||
      state.header.userData.FreeTicketNotification.UserAssignedTickets > 0 ||
      state.header.userData.FreeTicketNotification.SubscriptionTickets > 0 ||
      state.header.userData.FreeTicketNotification.UserRewardTickets > 0
    );
  });

export const useHeaderIsLoading = () => useAppSelector(state => state.header.isLoading);
